import { FaListAlt, FaCarSide, FaInfoCircle, FaLock, FaEnvelope } from "react-icons/fa";
import { FaShip } from "react-icons/fa6";
export const MediaSidebarData = [
  {
    title: "Brands",
    icon: FaListAlt, // 📋 for brands
    childrens: [
      { title: "BMW", path: "/brand/bmw" },
      { title: "Daihatsu", path: "/brand/daihatsu" },
      { title: "Honda", path: "/brand/honda" },
      { title: "Mazda", path: "/brand/mazda" },
      { title: "Mercedes", path: "/brand/mercedes" },
      { title: "Mitsubishi", path: "/brand/mitsubishi" },
      { title: "Nissan", path: "/brand/nissan" },
      { title: "Peugeot", path: "/brand/peugeot" },
      { title: "Suzuki", path: "/brand/suzuki" },
      { title: "Toyota", path: "/brand/toyota" },
    ],

  },
  {
    title: "Local Vehicles",
    icon: FaCarSide, // 🚗 vehicles
    path: "/vehicles",
  },
  {
    title: "Enroute Vehicles",
    icon: FaCarSide, // 🚗 vehicles
    path: "/enroute",
  },  
  {
    title: "Import With Us",
    icon: FaShip, // 🚢 importing cars from abroad
    path: "/import-guide",
  },
   {
    title: "Shop From Japan",
    icon: FaShip, // 🚢 importing cars from abroad
    path: "/imports",
  },
  {
    title: "About",
    icon: FaInfoCircle, // ℹ️
    path: "/about",
  },
  {
    title: "Privacy Policy",
    icon: FaLock, // 🔒
    path: "/privacy-policy",
  },
  {
    title: "Contact Us",
    icon: FaEnvelope, // ✉️
    path: "/contact-us",
  },
];
